import * as yup from "yup"
import { GruppoDiRicerca, GruppoDiRicercaFormType } from "../../types"

export function initialValuesGruppo(immagine?: GruppoDiRicerca | GruppoDiRicercaFormType | undefined) {
  if (immagine) {
    return immagine
  }
  return {
    nome: "",
    descrizione: "",
    informazioni_aggiuntive: "",
    immagine: "",
    ordine: 0,
  }
}

export function validationSchemaGruppo() {
  return yup.object().shape({
    nome: yup.string().required("Il nome è obbligatorio"),
    descrizione: yup.string().required("La descrizione è obbligatoria"),
    informazioni_aggiuntive: yup.string(),
    immagine: yup.string().required("L'immagine è obbligatoria"),
    ordine: yup
      .number()
      .typeError("L'ordine deve essere un numero")
      .integer("L'ordine deve essere un numero intero")
      .min(0, "L'ordine deve essere maggiore o uguale a 0")
      .required("L'ordine è obbligatorio"),
  })
}
